var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background--dust"},[_c('div',{staticClass:"background--dust__mask"}),_vm._v(" "),_c('canvas',{ref:"canvas",staticClass:"background--dust__canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }